export default __webpack_public_path__ + "static/media/ic_shortcut_homecare.94706bba.png";